import axios from 'axios';

const service = axios.create({
    baseURL: 'https://www.atzone.net/community', // api 的 base_url
    // baseURL: 'http://t1x9598098.iok.la:37975/community',
    // baseURL: 'http://8.129.107.101:23532/community',
    // baseURL: 'https://ctjdwx.cdqingyang.gov.cn',
    timeout: 5000
});

service.interceptors.request.use(
    config => {
        return config;
    },
    error => {
        console.log(error);
        return Promise.reject();
    }
);

service.interceptors.response.use(
    response => {
        if (response.status === 200) {
            return response.data;
        } else {
            Promise.reject();
        }
    },
    error => {
        console.log(error);
        return Promise.reject();
    }
);

export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js